import { connect } from 'react-redux';

import TriggerInputsList from 'app/developer-v3/pages/triggers/TriggerInputsList/TriggerInputsList';
import { isCurrentAppDefinitionSaving } from 'app/developer-v3/selectors';

const mapStateToProps = state => ({
  isSaving: isCurrentAppDefinitionSaving(state),
});

export default connect(mapStateToProps)(TriggerInputsList);
